module.exports = __webpack_public_path__ + "img/dialog-background.1f2eaa4.jpg";